export const processedInvoicesExcelColumnDefs = [
	{
		header: "Kunde",
		accessor: "companyDisplayName",
		type: "string",
	},
	{
		header: "Rechnungsnummer",
		accessor: "invoiceNumber",
		type: "string",
	},
	{
		header: "Rechnungsbetrag (brutto)",
		accessor: "invoiceTotalCents",
		type: "currency",
	},
	{
		header: "Leistungszeitraum",
		accessor: "deliveryPeriodFormatted",
		type: "string",
	},
	{
		header: "Versendet am",
		accessor: "transactionDate",
		type: "date",
	},
	{
		header: "Gebucht am",
		accessor: "sentAt",
		type: "date",
	},
	{
		header: "Bemerkungen",
		accessor: "comment",
		type: "string",
	},
];